// Translations for ES (Español), EN (English), SK (Slovak)
// Flag images served from flagcdn (works consistently across Windows, Android, etc.
// — many systems don't render regional-indicator emoji as flags)
export const LANGUAGES = [
  { code: "es",    label: "Español",    flag: "🇪🇸", flagUrl: "https://flagcdn.com/w40/es.png", flagUrl2x: "https://flagcdn.com/w80/es.png" },
  { code: "en",    label: "English",    flag: "🇺🇸", flagUrl: "https://flagcdn.com/w40/us.png", flagUrl2x: "https://flagcdn.com/w80/us.png" },
  { code: "sk",    label: "Slovenčina", flag: "🇸🇰", flagUrl: "https://flagcdn.com/w40/sk.png", flagUrl2x: "https://flagcdn.com/w80/sk.png" },
  { code: "de",    label: "Deutsch",    flag: "🇩🇪", flagUrl: "https://flagcdn.com/w40/de.png", flagUrl2x: "https://flagcdn.com/w80/de.png" },
  { code: "zh-CN", label: "简体中文",     flag: "🇨🇳", flagUrl: "https://flagcdn.com/w40/cn.png", flagUrl2x: "https://flagcdn.com/w80/cn.png" },
];

// SEO metadata per language
export const SEO = {
  es: {
    title: "REBEL · Ecosistema Crypto + IA · Trading TrendIA y Educación Web3 TopWallet",
    description:
      "REBEL es el ecosistema crypto definitivo: TrendIA, app de trading con IA, señales en vivo, mapas de liquidez y motor Quant-4X; y TopWallet, plataforma educativa Web3 para aprender wallets, blockchain, DeFi y seguridad. Aprende y opera con ventaja institucional.",
    keywords:
      "trading crypto, IA crypto, app trading bitcoin, señales crypto, herramientas crypto, aprender crypto, blockchain, Web3, DeFi, wallet, criptomonedas, Bitcoin, Ethereum, Solana, análisis técnico cripto, liquidaciones crypto, smart money, TrendIA, TopWallet, REBEL",
    og_title: "REBEL · Trading IA + Educación Web3 · La rebelión del dinero digital",
    og_description:
      "Dos productos. Una visión. TrendIA: trading impulsado por IA con motor Quant-4X. TopWallet: aprende Web3, blockchain y DeFi paso a paso. Únete a la rebelión.",
  },
  en: {
    title: "REBEL · Crypto + AI Ecosystem · TrendIA Trading & TopWallet Web3 Education",
    description:
      "REBEL is the ultimate crypto ecosystem: TrendIA, an AI-powered trading app with live signals, liquidity maps and the Quant-4X engine; and TopWallet, a Web3 learning platform for wallets, blockchain, DeFi and security. Learn and trade with institutional edge.",
    keywords:
      "crypto trading, AI crypto, bitcoin trading app, crypto signals, crypto tools, learn crypto, blockchain, Web3, DeFi, wallet, cryptocurrency, Bitcoin, Ethereum, Solana, crypto technical analysis, liquidations, smart money flow, TrendIA, TopWallet, REBEL",
    og_title: "REBEL · AI Trading + Web3 Education · The rebellion of digital money",
    og_description:
      "Two products. One vision. TrendIA: AI-powered trading with the Quant-4X engine. TopWallet: learn Web3, blockchain and DeFi step by step. Join the rebellion.",
  },
  sk: {
    title: "REBEL · Crypto + AI ekosystém · TrendIA trading a TopWallet Web3 vzdelávanie",
    description:
      "REBEL je krypto ekosystém novej generácie: TrendIA — AI trading aplikácia so živými signálmi, mapami likvidity a motorom Quant-4X; a TopWallet — platforma pre Web3 vzdelávanie o peňaženkách, blockchaine, DeFi a bezpečnosti.",
    keywords:
      "krypto trading, AI krypto, bitcoin obchodovanie, krypto signály, krypto nástroje, naučiť sa krypto, blockchain, Web3, DeFi, peňaženka, kryptomeny, Bitcoin, Ethereum, Solana, technická analýza, likvidácie, smart money, TrendIA, TopWallet, REBEL",
    og_title: "REBEL · AI Trading + Web3 vzdelávanie · Revolúcia digitálnych peňazí",
    og_description:
      "Dva produkty. Jedna vízia. TrendIA: AI obchodovanie s motorom Quant-4X. TopWallet: nauč sa Web3, blockchain a DeFi krok za krokom. Pridaj sa k rebélii.",
  },
  de: {
    title: "REBEL · Krypto-Ökosystem + KI · Trading mit TrendIA und Web3-Bildung mit TopWallet",
    description: "REBEL ist das ultimative Krypto-Ökosystem: TrendIA, die Trading-App mit KI, Live-Signalen, Liquiditätskarten und Quant-4X-Engine; und TopWallet, die Web3-Bildungsplattform zum Erlernen von Wallets, Blockchain, DeFi und Sicherheit. Lerne und trade mit institutionellem Vorteil.",
    keywords: "Krypto-Trading, Krypto-KI, Bitcoin-Trading-App, Krypto-Signale, Krypto-Tools, Krypto lernen, Blockchain, Web3, DeFi, Wallet, Kryptowährungen, Bitcoin, Ethereum, Solana, technische Krypto-Analyse, Krypto-Liquidationen, Smart Money, TrendIA, TopWallet, REBEL",
    og_title: "REBEL · KI-Trading + Web3-Bildung · Die Rebellion des digitalen Geldes",
    og_description: "Zwei Produkte. Eine Vision. TrendIA: KI-getriebenes Trading mit Quant-4X-Engine. TopWallet: lerne Web3, Blockchain und DeFi Schritt für Schritt. Schließ dich der Rebellion an.",
  },
  "zh-CN": {
    title: "RE₿EL · 加密生态系统 + AI · TrendIA 交易与 TopWallet Web3 教育",
    description: "RE₿EL 是终极加密生态系统：TrendIA，基于 AI 的交易应用，提供实时信号、流动性地图和 Quant-4X 引擎；TopWallet，Web3 教育平台，学习钱包、区块链、DeFi 和安全。以机构级优势学习和交易。",
    keywords: "加密交易, AI 加密, 比特币交易应用, 加密信号, 加密工具, 学习加密, 区块链, Web3, DeFi, 钱包, 加密货币, Bitcoin, Ethereum, Solana, 加密技术分析, 加密强制平仓, 聪明钱, TrendIA, TopWallet, RE₿EL",
    og_title: "RE₿EL · AI 交易 + Web3 教育 · 数字货币的革命",
    og_description: "两个产品。一个愿景。TrendIA：基于 AI 驱动的交易，配备 Quant-4X 引擎。TopWallet：循序渐进学习 Web3、区块链和 DeFi。加入革命。",
  },
};

export const translations = {
  es: {
    nav: { trendia: "TrendIA", topwallet: "TopWallet", liquidity_map: "Liquidity Map", launch: "Lanzamiento 2026", academy: "Academia RE₿EL · Gratis", vault: "Vault", governance: "Governance", burn: "Burn", login: "Acceder", account: "Mi Cuenta", logout: "Cerrar Sesión", upgrade: "Desbloquear PRO", section_learn: "APRENDE", section_trade: "OPERA", section_community: "COMUNIDAD", section_token: "TOKEN $RE₿EL", section_tools: "MIS HERRAMIENTAS" },
    auth: {
      login_title: "Acceder a tu cuenta",
      login_sub: "Continúa tu camino en la Academia RE₿EL",
      register_title: "Crear cuenta gratis",
      register_sub: "Lee las 51 lecciones · sin tarjeta",
      email: "Correo electrónico",
      password: "Contraseña",
      name: "Nombre (opcional)",
      submit_login: "Acceder",
      submit_register: "Crear cuenta",
      google_btn: "Continuar con Google",
      or_divider: "o",
      google_processing: "Verificando con Google…",
      switch_to_register: "¿No tienes cuenta? Crear una",
      switch_to_login: "¿Ya tienes cuenta? Acceder",
      close: "Cerrar",
      error_generic: "Algo salió mal. Inténtalo de nuevo.",
      free_perks: "Acceso gratis a las 51 lecciones",
      pro_perks: "Voz Onyx + Mentor IA con 39,90€ pago único",
      google_linked: "Conectado vía Google",
    },
    pro: {
      gate_title: "FUNCIÓN PRO",
      gate_listen: "Desbloquea la voz hiperrealista Onyx para escuchar las 51 lecciones",
      gate_mentor: "Conversa con el Mentor IA (Claude Sonnet 4.5) sobre cualquier lección",
      price_label: "PAGO ÚNICO",
      price: "39,90 €",
      lifetime: "Acceso de por vida",
      cta_unlock: "Desbloquear PRO",
      cta_login_first: "Acceder para desbloquear",
      includes_title: "Incluye:",
      includes: [
        "Voz humana Onyx en todas las lecciones",
        "Mentor IA personal con Claude Sonnet 4.5",
        "Contexto inteligente por lección",
        "Acceso vitalicio · sin renovaciones",
      ],
      processing: "Procesando tu pago…",
      success: "¡Bienvenido al ecosistema PRO! 🎉",
      cancelled: "Pago cancelado. Cuando quieras retomar, estamos aquí.",
      trial_expired_title: "¡Has completado las 51 lecciones! 🎉",
      trial_expired_sub: "Tu acceso de prueba terminó. Adquiere el PRO de por vida para seguir usando el Mentor IA y la voz Onyx siempre que quieras.",
      trial_used_listen_title: "Ya has usado tu prueba gratis de la voz Onyx 🎧",
      trial_used_mentor_title: "Ya has usado tu mensaje gratis con el Mentor IA 🤖",
      trial_used_sub: "Para seguir escuchando lecciones con voz Onyx y conversando con el Mentor IA cuantas veces quieras, adquiere el PRO de por vida.",
      // ── A/B variant B · emotional copy ─────────────────────────────
      gate_listen_b: "Tu lección, narrada con la voz Onyx que parece humana 🎧",
      gate_mentor_b: "Tu Mentor IA personal te espera, por menos del precio de una pizza 🍕",
      trial_used_listen_title_b: "La voz Onyx te enganchó, ¿verdad? 🎧",
      trial_used_mentor_title_b: "Una conversación no es suficiente con un mentor así 🤖",
      trial_used_sub_b: "Mentor IA + voz Onyx ilimitados de por vida. Por 39,90 € una vez. Cancelar nunca, porque no hay nada que cancelar.",
      cta_unlock_b: "Quiero el PRO de por vida",
    },
    hero: {
      eyebrow: "El ecosistema REBEL · Lanzamiento",
      title_1: "La rebelión del",
      title_2: "dinero digital",
      title_3: "ha comenzado",
      subtitle:
        "7 herramientas. Una sola visión. TrendIA, R₿L Coin, Academia, Shadow Network, Shadow Market, Liquidity Map y TopWallet. El ecosistema crypto más completo al alcance de cualquiera. Bienvenido a la rebelión.",
      cta_primary: "Explorar TrendIA",
      cta_secondary: "Descubrir TopWallet",
      scroll: "Desliza para explorar",
    },
    trendia: {
      eyebrow: "Producto 01 · App de Trading IA",
      title: "TrendIA",
      tagline: "Inteligencia artificial para traders implacables",
      description:
        "Señales de alta probabilidad, mapas de liquidez en vivo, análisis institucional y precisión milimétrica — todo en tu bolsillo, impulsado por el motor Quant-4X.",
      features: [
        { title: "IA Predictiva", desc: "Modelos avanzados que anticipan movimientos del mercado." },
        { title: "Liquidaciones en Vivo", desc: "Monitorea zonas críticas y clusters en tiempo real." },
        { title: "Análisis Avanzado", desc: "Gráficos, indicadores y tendencias institucionales." },
        { title: "Seguridad Total", desc: "Tu información protegida con tecnología de élite." },
      ],
      download_play: "Google Play",
      download_web: "Versión Web",
      coming_soon: "Próximamente",
      available_now: "Disponible Ahora",
      gallery_eyebrow: "Capacidades · App TrendIA",
      gallery_title: "Una IA. Siete superpoderes.",
      gallery_subtitle:
        "Cada pantalla resuelve un problema real del trader. Todo conectado al motor Quant-4X.",
      gallery: [
        {
          tag: "Liquidez",
          title: "Liquidaciones en Tiempo Real",
          desc: "Mapa en vivo de clusters de liquidación con probabilidades milimétricas para BTC, ETH, SOL, ZEC y más. Visualiza zonas críticas donde longs y shorts pueden detonar en cascada, con porcentajes objetivos, distancia al precio actual y dirección probable del movimiento. Opera reaccionando al libro de órdenes, no a corazonadas.",
        },
        {
          tag: "Análisis",
          title: "Análisis Inteligente · Decisiones Precisas",
          desc: "Señal IA en tiempo real con confianza histórica del 95% y precisión validada del 92.4%. Indica dirección, volatilidad, momentum, fuerza, liquidez y sentimiento en una sola pantalla. Mapa de calor del mercado para BTC, ETH, SOL y ZEC con noticias de Cointelegraph y The Block integradas.",
        },
        {
          tag: "IA Predictiva",
          title: "IA para Traders Implacables",
          desc: "Predicción IA con target proyectado, soporte fuerte y zona de demanda calculados al instante. Smart Money Flow muestra big buyers, big sellers y net flow institucional. Monitor del Quant-4X Engine con precisión del 96.7% y latencia de 23ms — análisis institucional al alcance de tu pulgar.",
        },
        {
          tag: "Sentimiento",
          title: "Sentimiento de Mercado en Vivo",
          desc: "Fear & Greed Index combinado con AI Trend Analysis institucional. Visualiza el nivel exacto de codicia o miedo del mercado en escala 0–100, con interpretación IA del posible impacto en el precio y flujo de órdenes en vivo. La emoción del mercado traducida a datos accionables.",
        },
        {
          tag: "Eventos",
          title: "Calendario Económico IA",
          desc: "Eventos macro críticos — CPI inflation reports, FOMC meeting minutes, US Senate crypto regulation hearings, actualizaciones Ethereum — con impacto IA evaluado como CRÍTICO, MEDIO o BAJO. Filtros por país y categoría, interpretación IA del posible impacto y decisiones informadas antes que la masa.",
        },
        {
          tag: "On-Chain",
          title: "Whale Watch & Crypto News IA",
          desc: "Detecta cada movimiento institucional con el módulo Whale Watch dedicado. Crypto News con AI Sentiment analiza titulares de Federal Reserve, BlackRock, SEC y más en tiempo real, etiquetando cada noticia como ALCISTA, BAJISTA o NEUTRAL. Tu edge contra el ruido del mercado.",
        },
        {
          tag: "Momentum",
          title: "Short Squeeze Detector",
          desc: "La IA detecta compresiones de shorts antes de la explosión. Identifica precio, predicción IA y zonas de gatillo con probabilidades exactas. Detección temprana, modelos predictivos avanzados y módulo de objetivo IA para entrar antes del squeeze, no después. La diferencia entre seguir la subida y ser el origen.",
        },
      ],
    },
    topwallet: {
      eyebrow: "Producto 02 · Educación Web3",
      title: "TOPWALLET",
      tagline: "Tu dinero, tu control",
      description:
        "Una plataforma moderna enfocada en el dinero digital, blockchain y Web3. Aprende paso a paso cómo funciona la nueva economía: wallets, redes, DeFi, seguridad y transferencias — con infografías profesionales y explicaciones simples.",
      open_web: "Abrir Versión Web",
      under_construction: "En construcción",
      under_construction_note: "Estamos construyendo TopWallet. Vuelve pronto para acceder a la plataforma.",
      placeholder_note: "Capturas e imágenes finales próximamente.",
      compare_cta: "Comparador de 35 Wallets",
      concepts: [
        {
          title: "Carteras Digitales",
          desc: "Aprende qué son las wallets, cómo crearlas y cómo proteger tus claves privadas.",
        },
        {
          title: "Redes Blockchain",
          desc: "Descubre cómo funcionan las redes descentralizadas, nodos y consenso.",
        },
        {
          title: "Seguridad Digital",
          desc: "Frases semilla, hardware wallets y buenas prácticas anti-estafa.",
        },
        {
          title: "DeFi & Transferencias",
          desc: "Tokens, swaps, staking y movimientos on-chain explicados visualmente.",
        },
      ],
    },
    cta_band: {
      title: "Únete a la rebelión",
      subtitle: "Sé de los primeros en operar y aprender con el ecosistema REBEL.",
      button: "Entrar al ecosistema",
    },
    footer: {
      tagline: "Una marca REBEL · Trading + Educación Web3",
      rights: "Todos los derechos reservados.",
      ecosystem: "Ecosistema",
      legal: "Legal",
      terms: "Términos",
      privacy: "Privacidad",
      contact: "Contacto",
      blog: "Blog",
      resources: "Recursos",
    },
    social: {
      title: "Conecta con RE₿EL",
      subtitle: "Sigue nuestros análisis institucionales, inteligencia artificial, resultados reales, actualizaciones del mercado y contenido exclusivo de la comunidad RE₿EL.",
      follow: "Seguir",
      visit: "Visitar",
      x: { handle: "@ShibaInuWorld_", desc: "Inteligencia institucional para criptomonedas impulsada por IA. Análisis en tiempo real, liquidez, Smart Money y oportunidades de mercado." },
      youtube: { handle: "@satoshin_gmx", desc: "Análisis de mercado, Bitcoin, criptomonedas, inteligencia artificial aplicada al trading y educación financiera." },
      facebook: { handle: "Peter Stanga", desc: "Fundador de RE₿EL. Desarrollo de inteligencia artificial aplicada al mercado crypto, análisis institucional y construcción del ecosistema RE₿EL." },
      telegram: { handle: "@RebelBTCoficial", desc: "Canal oficial de RE₿EL. Análisis en tiempo real, alertas de liquidaciones y novedades de la plataforma.", cta: "Unirse" },
      website: { handle: "rebelbtc.com", desc: "Plataforma profesional de inteligencia artificial para análisis de criptomonedas, liquidez institucional y seguimiento Smart Money." },
    },
  },
  en: {
    nav: { trendia: "TrendIA", topwallet: "TopWallet", liquidity_map: "Liquidity Map", launch: "Launch 2026", academy: "RE₿EL Academy · Free", vault: "Vault", governance: "Governance", burn: "Burn", login: "Sign in", account: "My Account", logout: "Sign out", upgrade: "Unlock PRO", section_learn: "LEARN", section_trade: "TRADE", section_community: "COMMUNITY", section_token: "TOKEN $RE₿EL", section_tools: "MY TOOLS" },
    auth: {
      login_title: "Sign in to your account",
      login_sub: "Continue your RE₿EL Academy journey",
      register_title: "Create free account",
      register_sub: "Read all 51 lessons · no card required",
      email: "Email",
      password: "Password",
      name: "Name (optional)",
      submit_login: "Sign in",
      submit_register: "Create account",
      google_btn: "Continue with Google",
      or_divider: "or",
      google_processing: "Verifying with Google…",
      switch_to_register: "No account yet? Create one",
      switch_to_login: "Already have an account? Sign in",
      close: "Close",
      error_generic: "Something went wrong. Please try again.",
      free_perks: "Free access to all 51 lessons",
      pro_perks: "Onyx voice + AI Mentor for €39.90 one-time",
      google_linked: "Connected via Google",
    },
    pro: {
      gate_title: "PRO FEATURE",
      gate_listen: "Unlock the hyper-realistic Onyx voice to listen to all 51 lessons",
      gate_mentor: "Chat with the AI Mentor (Claude Sonnet 4.5) about any lesson",
      price_label: "ONE-TIME",
      price: "€39.90",
      lifetime: "Lifetime access",
      cta_unlock: "Unlock PRO",
      cta_login_first: "Sign in to unlock",
      includes_title: "Includes:",
      includes: [
        "Onyx human voice on every lesson",
        "Personal AI Mentor with Claude Sonnet 4.5",
        "Smart lesson-aware context",
        "Lifetime access · no renewals",
      ],
      processing: "Processing your payment…",
      success: "Welcome to the PRO ecosystem! 🎉",
      cancelled: "Payment cancelled. Whenever you're ready, we're here.",
      trial_expired_title: "You completed all 51 lessons! 🎉",
      trial_expired_sub: "Your free trial is over. Get the lifetime PRO plan to keep using the AI Mentor and the Onyx voice forever.",
      trial_used_listen_title: "You already used your free try of the Onyx voice 🎧",
      trial_used_mentor_title: "You already used your free message with the AI Mentor 🤖",
      trial_used_sub: "To keep listening to lessons with the Onyx voice and chatting with the AI Mentor as many times as you want, get the lifetime PRO plan.",
      // ── A/B variant B · emotional copy ─────────────────────────────
      gate_listen_b: "Your lessons, narrated by the Onyx voice that sounds human 🎧",
      gate_mentor_b: "Your personal AI Mentor is waiting, for less than the price of a pizza 🍕",
      trial_used_listen_title_b: "The Onyx voice got you hooked, didn't it? 🎧",
      trial_used_mentor_title_b: "One conversation isn't enough with a mentor like this 🤖",
      trial_used_sub_b: "AI Mentor + Onyx voice, unlimited and lifetime. €39.90 once. Cancel never — because there's nothing to cancel.",
      cta_unlock_b: "I want lifetime PRO",
    },
    hero: {
      eyebrow: "The REBEL ecosystem · Launch",
      title_1: "The rebellion of",
      title_2: "digital money",
      title_3: "has begun",
      subtitle:
        "7 tools. One vision. TrendIA, R₿L Coin, Academy, Shadow Network, Shadow Market, Liquidity Map and TopWallet. The most complete crypto ecosystem within everyone's reach. Welcome to the rebellion.",
      cta_primary: "Explore TrendIA",
      cta_secondary: "Discover TopWallet",
      scroll: "Scroll to explore",
    },
    trendia: {
      eyebrow: "Product 01 · AI Trading App",
      title: "TrendIA",
      tagline: "Artificial intelligence for relentless traders",
      description:
        "High-probability signals, live liquidity maps, institutional analysis and millimetric precision — all in your pocket, powered by the Quant-4X engine.",
      features: [
        { title: "Predictive AI", desc: "Advanced models anticipating market moves." },
        { title: "Live Liquidations", desc: "Monitor critical zones and clusters in real time." },
        { title: "Advanced Analysis", desc: "Charts, indicators and institutional trends." },
        { title: "Total Security", desc: "Your data protected with elite-grade technology." },
      ],
      download_play: "Google Play",
      download_web: "Web Version",
      coming_soon: "Coming Soon",
      available_now: "Available Now",
      gallery_eyebrow: "Capabilities · TrendIA App",
      gallery_title: "One AI. Seven superpowers.",
      gallery_subtitle:
        "Every screen solves a real trader problem. All wired into the Quant-4X engine.",
      gallery: [
        {
          tag: "Liquidity",
          title: "Real-Time Liquidations",
          desc: "Live map of liquidation clusters with millimetric probabilities for BTC, ETH, SOL, ZEC and more. See the exact zones where longs and shorts may cascade, with target percentages, distance to current price and the likely direction of the next move. Trade reacting to the order book — not to gut feelings.",
        },
        {
          tag: "Analysis",
          title: "Smart Analysis · Precise Decisions",
          desc: "Real-time AI signal with 95% historical confidence and 92.4% validated accuracy. Direction, volatility, momentum, strength, liquidity and sentiment — all on one screen. Market heat-map across BTC, ETH, SOL and ZEC, with Cointelegraph and The Block headlines integrated.",
        },
        {
          tag: "Predictive AI",
          title: "AI for Relentless Traders",
          desc: "AI prediction with projected target, strong support and demand zone calculated instantly. Smart Money Flow surfaces big buyers, big sellers and institutional net flow. Quant-4X Engine monitor with 96.7% accuracy and 23ms latency — institutional analysis in your pocket.",
        },
        {
          tag: "Sentiment",
          title: "Live Market Sentiment",
          desc: "Fear & Greed Index paired with institutional AI Trend Analysis. See the exact greed-or-fear reading on a 0–100 scale, with AI interpretation of probable price impact and live order flow. Market emotion, translated into actionable data.",
        },
        {
          tag: "Events",
          title: "AI Economic Calendar",
          desc: "Critical macro events — CPI inflation reports, FOMC meeting minutes, US Senate crypto regulation hearings, Ethereum upgrades — with AI-rated impact: CRITICAL, MEDIUM or LOW. Filters by country and category, AI interpretation of each move and informed decisions before the crowd.",
        },
        {
          tag: "On-Chain",
          title: "Whale Watch & Crypto News AI",
          desc: "Catch every institutional move with the dedicated Whale Watch module. Crypto News with AI Sentiment scans Federal Reserve, BlackRock, SEC headlines and more in real time, tagging each story as BULLISH, BEARISH or NEUTRAL. Your edge against market noise.",
        },
        {
          tag: "Momentum",
          title: "Short Squeeze Detector",
          desc: "AI detects short compressions before the explosion. Identifies price, AI prediction and trigger zones with exact probabilities. Early detection, advanced predictive models and an AI target module to enter before the squeeze — not after. The difference between chasing the move and starting it.",
        },
      ],
    },
    topwallet: {
      eyebrow: "Product 02 · Web3 Education",
      title: "TOPWALLET",
      tagline: "Your money, your control",
      description:
        "A modern platform focused on digital money, blockchain and Web3. Learn step by step how the new economy works: wallets, networks, DeFi, security and transfers — with professional infographics and simple explanations.",
      open_web: "Open Web Version",
      under_construction: "Under Construction",
      under_construction_note: "We're building TopWallet. Check back soon to access the platform.",
      placeholder_note: "Final screenshots and visuals coming soon.",
      compare_cta: "Compare 35 Wallets",
      concepts: [
        { title: "Digital Wallets", desc: "Learn what wallets are, how to create them and protect your private keys." },
        { title: "Blockchain Networks", desc: "Discover how decentralized networks, nodes and consensus work." },
        { title: "Digital Security", desc: "Seed phrases, hardware wallets and anti-scam best practices." },
        { title: "DeFi & Transfers", desc: "Tokens, swaps, staking and on-chain movements visually explained." },
      ],
    },
    cta_band: {
      title: "Join the rebellion",
      subtitle: "Be among the first to trade and learn with the REBEL ecosystem.",
      button: "Enter the ecosystem",
    },
    footer: {
      tagline: "A REBEL brand · Trading + Web3 Education",
      rights: "All rights reserved.",
      ecosystem: "Ecosystem",
      legal: "Legal",
      terms: "Terms",
      privacy: "Privacy",
      contact: "Contact",
      blog: "Blog",
      resources: "Resources",
    },
    social: {
      title: "Connect with RE₿EL",
      subtitle: "Follow our institutional market analysis, artificial intelligence insights, real trading results, market updates and exclusive RE₿EL community content.",
      follow: "Follow",
      visit: "Visit",
      x: { handle: "@ShibaInuWorld_", desc: "Institutional crypto intelligence powered by AI. Real-time analysis, liquidity tracking, Smart Money monitoring and market opportunities." },
      youtube: { handle: "@satoshin_gmx", desc: "Market analysis, Bitcoin, cryptocurrencies, AI-powered trading insights and financial education." },
      facebook: { handle: "Peter Stanga", desc: "Founder of RE₿EL. Building AI-powered crypto intelligence, institutional market analysis and the RE₿EL ecosystem." },
      telegram: { handle: "@RebelBTCoficial", desc: "Official RE₿EL channel. Real-time analysis, liquidation alerts and platform updates.", cta: "Join" },
      website: { handle: "rebelbtc.com", desc: "Professional AI platform for crypto market analysis, institutional liquidity and Smart Money tracking." },
    },
  },
  sk: {
    nav: { trendia: "TrendIA", topwallet: "TopWallet", liquidity_map: "Liquidity Map", launch: "Spustenie 2026", academy: "RE₿EL Akadémia · Zdarma", vault: "Vault", governance: "Správa", burn: "Spáliť", login: "Prihlásiť sa", account: "Môj účet", logout: "Odhlásiť sa", upgrade: "Odomknúť PRO", section_learn: "UČ SA", section_trade: "OBCHODUJ", section_community: "KOMUNITA", section_token: "TOKEN $RE₿EL", section_tools: "MOJE NÁSTROJE" },
    auth: {
      login_title: "Prihlás sa do svojho účtu",
      login_sub: "Pokračuj v ceste RE₿EL Akadémie",
      register_title: "Vytvoriť účet zdarma",
      register_sub: "Čítaj všetkých 51 lekcií · bez karty",
      email: "E-mail",
      password: "Heslo",
      name: "Meno (voliteľné)",
      submit_login: "Prihlásiť",
      submit_register: "Vytvoriť účet",
      google_btn: "Pokračovať s Google",
      or_divider: "alebo",
      google_processing: "Overujem s Google…",
      switch_to_register: "Ešte nemáš účet? Vytvor si ho",
      switch_to_login: "Už máš účet? Prihlás sa",
      close: "Zavrieť",
      error_generic: "Niečo sa pokazilo. Skús to znova.",
      free_perks: "Zdarma prístup ku všetkým 51 lekciám",
      pro_perks: "Onyx hlas + AI Mentor za 39,90 € jednorazovo",
      google_linked: "Pripojené cez Google",
    },
    pro: {
      gate_title: "PRO FUNKCIA",
      gate_listen: "Odomkni hyperrealistický hlas Onyx pre počúvanie všetkých 51 lekcií",
      gate_mentor: "Rozprávaj sa s AI Mentorom (Claude Sonnet 4.5) o ktorejkoľvek lekcii",
      price_label: "JEDNORAZOVO",
      price: "39,90 €",
      lifetime: "Doživotný prístup",
      cta_unlock: "Odomknúť PRO",
      cta_login_first: "Prihlás sa na odomknutie",
      includes_title: "Obsahuje:",
      includes: [
        "Ľudský hlas Onyx pri každej lekcii",
        "Osobný AI Mentor s Claude Sonnet 4.5",
        "Inteligentný kontext lekcie",
        "Doživotný prístup · bez obnov",
      ],
      processing: "Spracovávam tvoju platbu…",
      success: "Vitaj v PRO ekosystéme! 🎉",
      cancelled: "Platba zrušená. Sme tu, keď budeš pripravený.",
      trial_expired_title: "Dokončil si všetkých 51 lekcií! 🎉",
      trial_expired_sub: "Bezplatná skúšobná verzia skončila. Získaj doživotný PRO plán a používaj AI Mentora a hlas Onyx kedykoľvek.",
      trial_used_listen_title: "Už si využil svoju bezplatnú skúšku hlasu Onyx 🎧",
      trial_used_mentor_title: "Už si využil svoju bezplatnú správu s AI Mentorom 🤖",
      trial_used_sub: "Aby si mohol počúvať lekcie s hlasom Onyx a rozprávať sa s AI Mentorom toľko, koľko chceš, získaj doživotný PRO plán.",
      // ── A/B variant B · emotional copy ─────────────────────────────
      gate_listen_b: "Tvoje lekcie, rozprávané hlasom Onyx, ktorý znie ľudsky 🎧",
      gate_mentor_b: "Tvoj osobný AI Mentor čaká, za menej ako pizza 🍕",
      trial_used_listen_title_b: "Hlas Onyx ťa dostal, však? 🎧",
      trial_used_mentor_title_b: "Jedna konverzácia s takýmto mentorom nestačí 🤖",
      trial_used_sub_b: "AI Mentor + hlas Onyx, neobmedzene a doživotne. 39,90 € raz. Zrušiť nikdy — pretože nie je čo rušiť.",
      cta_unlock_b: "Chcem PRO doživotne",
    },
    hero: {
      eyebrow: "Ekosystém REBEL · Spustenie",
      title_1: "Revolúcia",
      title_2: "digitálnych peňazí",
      title_3: "sa začala",
      subtitle:
        "7 nástrojov. Jedna vízia. TrendIA, R₿L Coin, Akadémia, Shadow Network, Shadow Market, Liquidity Map a TopWallet. Najkompletnejší krypto ekosystém dostupný každému. Vitaj v rebélii.",
      cta_primary: "Preskúmať TrendIA",
      cta_secondary: "Objaviť TopWallet",
      scroll: "Posuň pre viac",
    },
    trendia: {
      eyebrow: "Produkt 01 · AI Trading aplikácia",
      title: "TrendIA",
      tagline: "Umelá inteligencia pre neúnavných traderov",
      description:
        "Vysoko pravdepodobné signály, živé mapy likvidity, inštitucionálna analýza a milimetrová presnosť — všetko vo vrecku, poháňané motorom Quant-4X.",
      features: [
        { title: "Prediktívna AI", desc: "Pokročilé modely anticipujúce pohyby trhu." },
        { title: "Likvidácie naživo", desc: "Sleduj kritické zóny a klastre v reálnom čase." },
        { title: "Pokročilá analýza", desc: "Grafy, indikátory a inštitucionálne trendy." },
        { title: "Plná bezpečnosť", desc: "Tvoje dáta chránené elitnou technológiou." },
      ],
      download_play: "Google Play",
      download_web: "Webová verzia",
      coming_soon: "Čoskoro",
      available_now: "Dostupné teraz",
      gallery_eyebrow: "Schopnosti · TrendIA aplikácia",
      gallery_title: "Jedna AI. Sedem superschopností.",
      gallery_subtitle:
        "Každá obrazovka rieši reálny problém tradera. Všetko napojené na motor Quant-4X.",
      gallery: [
        {
          tag: "Likvidita",
          title: "Likvidácie v reálnom čase",
          desc: "Živá mapa klastrov likvidácie s milimetrovou pravdepodobnosťou pre BTC, ETH, SOL, ZEC a ďalšie. Sleduj presné zóny, kde môžu longy a shorty kaskádovo padnúť — s cieľovými percentami, vzdialenosťou od aktuálnej ceny a pravdepodobným smerom pohybu. Obchoduj reaguj na order book, nie na pocity.",
        },
        {
          tag: "Analýza",
          title: "Inteligentná analýza · Presné rozhodnutia",
          desc: "AI signál v reálnom čase s 95% historickou spoľahlivosťou a 92.4% overenou presnosťou. Smer, volatilita, momentum, sila, likvidita a sentiment — všetko na jednej obrazovke. Mapa tepla trhu pre BTC, ETH, SOL a ZEC s integrovanými titulkami Cointelegraph a The Block.",
        },
        {
          tag: "Prediktívna AI",
          title: "AI pre neúnavných traderov",
          desc: "AI predikcia s projekciou cieľa, silnou podporou a zónou dopytu vypočítanými okamžite. Smart Money Flow ukazuje veľkých kupcov, predajcov a inštitucionálny net flow. Monitor Quant-4X Engine s presnosťou 96.7% a latenciou 23ms — inštitucionálna analýza vo vrecku.",
        },
        {
          tag: "Sentiment",
          title: "Sentiment trhu naživo",
          desc: "Fear & Greed Index spojený s inštitucionálnou AI Trend Analysis. Presný stupeň chamtivosti alebo strachu na škále 0–100, s AI interpretáciou pravdepodobného dopadu na cenu a živý order flow. Emócia trhu preložená do akčných dát.",
        },
        {
          tag: "Udalosti",
          title: "AI ekonomický kalendár",
          desc: "Kritické makro udalosti — CPI inflation reports, FOMC zápisnice, US Senate kryptomenové vypočutia, Ethereum upgrady — s AI hodnotením dopadu: KRITICKÝ, STREDNÝ alebo NÍZKY. Filtre podľa krajiny a kategórie, AI interpretácia dopadu a informované rozhodnutia skôr ako masa.",
        },
        {
          tag: "On-Chain",
          title: "Whale Watch & Crypto News AI",
          desc: "Zachyť každý inštitucionálny pohyb s modulom Whale Watch. Crypto News s AI Sentiment skenuje titulky Federal Reserve, BlackRock, SEC a ďalších v reálnom čase a označuje každý článok ako BÝČÍ, MEDVEDÍ alebo NEUTRÁLNY. Tvoja výhoda proti šumu trhu.",
        },
        {
          tag: "Momentum",
          title: "Detektor Short Squeeze",
          desc: "AI detekuje stlačenia shortov pred explóziou. Identifikuje cenu, AI predikciu a spúšťacie zóny s presnými pravdepodobnosťami. Včasná detekcia, pokročilé prediktívne modely a AI cieľový modul pre vstup pred squeeze — nie po ňom. Rozdiel medzi naháňaním pohybu a jeho štartom.",
        },
      ],
    },
    topwallet: {
      eyebrow: "Produkt 02 · Web3 vzdelávanie",
      title: "TOPWALLET",
      tagline: "Tvoje peniaze, tvoja kontrola",
      description:
        "Moderná platforma zameraná na digitálne peniaze, blockchain a Web3. Nauč sa krok za krokom, ako funguje nová ekonomika: peňaženky, siete, DeFi, bezpečnosť a prevody — s profesionálnymi infografikami a jednoduchými vysvetleniami.",
      open_web: "Otvoriť webovú verziu",
      under_construction: "V príprave",
      under_construction_note: "Pracujeme na TopWallet. Čoskoro sa vráť, aby si získal prístup k platforme.",
      placeholder_note: "Konečné snímky a vizuály už čoskoro.",
      compare_cta: "Porovnaj 35 peňaženiek",
      concepts: [
        { title: "Digitálne peňaženky", desc: "Zisti, čo sú wallety, ako ich vytvoriť a chrániť privátne kľúče." },
        { title: "Blockchain siete", desc: "Objav, ako fungujú decentralizované siete, uzly a konsenzus." },
        { title: "Digitálna bezpečnosť", desc: "Seed frázy, hardvérové peňaženky a osvedčené postupy proti podvodom." },
        { title: "DeFi a prevody", desc: "Tokeny, swapy, staking a on-chain pohyby vysvetlené vizuálne." },
      ],
    },
    cta_band: {
      title: "Pridaj sa k rebélii",
      subtitle: "Buď medzi prvými, ktorí obchodujú a učia sa s ekosystémom REBEL.",
      button: "Vstúpiť do ekosystému",
    },
    footer: {
      tagline: "Značka REBEL · Trading + Web3 vzdelávanie",
      rights: "Všetky práva vyhradené.",
      ecosystem: "Ekosystém",
      legal: "Právne",
      terms: "Podmienky",
      privacy: "Súkromie",
      contact: "Kontakt",
    },
    social: {
      title: "Pripojte sa k RE₿EL",
      subtitle: "Sledujte naše inštitucionálne analýzy trhu, umelú inteligenciu, reálne výsledky obchodovania, aktualizácie trhu a exkluzívny obsah komunity RE₿EL.",
      follow: "Sledovať",
      visit: "Navštíviť",
      x: { handle: "@ShibaInuWorld_", desc: "Inštitucionálna krypto inteligencia poháňaná AI. Analýza trhu v reálnom čase, sledovanie likvidity, Smart Money a trhových príležitostí." },
      youtube: { handle: "@satoshin_gmx", desc: "Analýzy trhu, Bitcoin, kryptomeny, AI pre trading a finančné vzdelávanie." },
      facebook: { handle: "Peter Stanga", desc: "Zakladateľ RE₿EL. Vývoj AI pre kryptomeny, inštitucionálne analýzy trhu a budovanie ekosystému RE₿EL." },
      telegram: { handle: "@RebelBTCoficial", desc: "Oficiálny kanál RE₿EL. Analýzy v reálnom čase, upozornenia na likvidácie a novinky platformy.", cta: "Pridať sa" },
      website: { handle: "rebelbtc.com", desc: "Profesionálna AI platforma pre analýzu kryptomien, inštitucionálnu likviditu a sledovanie Smart Money." },
    },
  },
  de: {
    nav: {
      trendia: "TrendIA",
      topwallet: "TopWallet",
      liquidity_map: "Liquidity Map",
      launch: "Launch 2026",
      academy: "RE₿EL Akademie · Kostenlos",
      vault: "Vault",
      governance: "Governance",
      burn: "Burn",
      login: "Anmelden",
      account: "Mein Konto",
      logout: "Abmelden",
      upgrade: "PRO freischalten",
      section_learn: "LERNEN",
      section_trade: "TRADEN",
      section_community: "COMMUNITY",
      section_token: "TOKEN $RE₿EL",
      section_tools: "MEINE TOOLS",
    },
    auth: {
      login_title: "Zu deinem Konto anmelden",
      login_sub: "Setze deinen Weg in der RE₿EL Akademie fort",
      register_title: "Kostenloses Konto erstellen",
      register_sub: "Lies die 51 Lektionen · ohne Kreditkarte",
      email: "E-Mail-Adresse",
      password: "Passwort",
      name: "Name (optional)",
      submit_login: "Anmelden",
      submit_register: "Konto erstellen",
      google_btn: "Mit Google fortfahren",
      or_divider: "oder",
      google_processing: "Verifizierung mit Google…",
      switch_to_register: "Noch kein Konto? Eines erstellen",
      switch_to_login: "Bereits ein Konto? Anmelden",
      close: "Schließen",
      error_generic: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      free_perks: "Kostenloser Zugang zu den 51 Lektionen",
      pro_perks: "Onyx Voice + KI-Mentor für 39,90€ Einmalzahlung",
      google_linked: "Verbunden via Google",
    },
    pro: {
      gate_title: "PRO FUNKTION",
      gate_listen: "Schalte die hyperrealistische Onyx-Stimme frei, um die 51 Lektionen zu hören",
      gate_mentor: "Unterhalte dich mit dem KI-Mentor (Claude Sonnet 4.5) über jede Lektion",
      price_label: "EINMALZAHLUNG",
      price: "39,90 €",
      lifetime: "Lebenslanger Zugang",
      cta_unlock: "PRO freischalten",
      cta_login_first: "Anmelden, um freizuschalten",
      includes_title: "Beinhaltet:",
      includes: [
        "Menschliche Onyx-Stimme in allen Lektionen",
        "Persönlicher KI-Mentor mit Claude Sonnet 4.5",
        "Intelligenter Kontext pro Lektion",
        "Lebenslanger Zugang · keine Verlängerungen"
      ],
      processing: "Deine Zahlung wird verarbeitet…",
      success: "Willkommen im PRO-Ökosystem! 🎉",
      cancelled: "Zahlung abgebrochen. Wenn du weitermachen möchtest, sind wir hier.",
      trial_expired_title: "Du hast die 51 Lektionen abgeschlossen! 🎉",
      trial_expired_sub: "Dein Testzugang ist abgelaufen. Erwerbe PRO auf Lebenszeit, um den KI-Mentor und die Onyx-Stimme jederzeit weiter zu nutzen.",
      trial_used_listen_title: "Du hast deine kostenlose Testversion der Onyx-Stimme bereits genutzt 🎧",
      trial_used_mentor_title: "Du hast deine kostenlose Nachricht mit dem KI-Mentor bereits genutzt 🤖",
      trial_used_sub: "Um weiterhin unbegrenzt Lektionen mit der Onyx-Stimme zu hören und mit dem KI-Mentor zu sprechen, erwerbe PRO auf Lebenszeit.",
      gate_listen_b: "Deine Lektion, erzählt mit der menschenähnlichen Onyx-Stimme 🎧",
      gate_mentor_b: "Dein persönlicher KI-Mentor wartet auf dich, für weniger als eine Pizza 🍕",
      trial_used_listen_title_b: "Die Onyx-Stimme hat dich süchtig gemacht, oder? 🎧",
      trial_used_mentor_title_b: "Ein Gespräch reicht nicht mit so einem Mentor 🤖",
      trial_used_sub_b: "Unbegrenzter KI-Mentor + Onyx-Stimme auf Lebenszeit. Für 39,90 € einmalig. Nie kündigen, weil es nichts zu kündigen gibt.",
      cta_unlock_b: "Ich will PRO auf Lebenszeit",
    },
    hero: {
      eyebrow: "Das REBEL-Ökosystem · Launch",
      title_1: "Die Rebellion des",
      title_2: "digitalen Geldes",
      title_3: "hat begonnen",
      subtitle: "7 Tools. Eine Vision. TrendIA, R₿L Coin, Akademie, Shadow Network, Shadow Market, Liquidity Map und TopWallet. Das umfassendste Crypto-Ökosystem für jeden zugänglich. Willkommen bei der Rebellion.",
      cta_primary: "TrendIA erkunden",
      cta_secondary: "TopWallet entdecken",
      scroll: "Scrollen zum Erkunden",
    },
    trendia: {
      eyebrow: "Produkt 01 · KI-Trading-App",
      title: "TrendIA",
      tagline: "Künstliche Intelligenz für gnadenlose Trader",
      description: "Hochwahrscheinlichkeits-Signale, Live-Liquiditätskarten, institutionelle Analysen und millimetergenaue Präzision — alles in deiner Tasche, angetrieben von der Quant-4X Engine.",
      features: [
        {
          title: "Prädiktive KI",
          desc: "Fortschrittliche Modelle, die Marktbewegungen antizipieren.",
        },
        {
          title: "Live-Liquidationen",
          desc: "Überwache kritische Zonen und Cluster in Echtzeit.",
        },
        {
          title: "Erweiterte Analyse",
          desc: "Charts, Indikatoren und institutionelle Trends.",
        },
        {
          title: "Totale Sicherheit",
          desc: "Deine Informationen geschützt mit Elite-Technologie.",
        }
      ],
      download_play: "Google Play",
      download_web: "Web-Version",
      coming_soon: "Demnächst",
      available_now: "Jetzt verfügbar",
      gallery_eyebrow: "Funktionen · TrendIA App",
      gallery_title: "Eine KI. Sieben Superkräfte.",
      gallery_subtitle: "Jeder Bildschirm löst ein echtes Trader-Problem. Alles verbunden mit der Quant-4X Engine.",
      gallery: [
        {
          tag: "Liquidität",
          title: "Liquidationen in Echtzeit",
          desc: "Live-Karte von Liquidations-Clustern mit millimetergenauer Wahrscheinlichkeit für BTC, ETH, SOL, ZEC und mehr. Visualisiere kritische Zonen, wo Longs und Shorts kaskadenförmig auslösen können, mit Ziel-Prozentsätzen, Distanz zum aktuellen Preis und wahrscheinlicher Bewegungsrichtung. Trade auf Basis des Orderbuchs, nicht auf Bauchgefühl.",
        },
        {
          tag: "Analyse",
          title: "Intelligente Analyse · Präzise Entscheidungen",
          desc: "KI-Signal in Echtzeit mit historischer Konfidenz von 95% und validierter Präzision von 92.4%. Zeigt Richtung, Volatilität, Momentum, Stärke, Liquidität und Sentiment auf einem Bildschirm. Markt-Heatmap für BTC, ETH, SOL und ZEC mit integrierten News von Cointelegraph und The Block.",
        },
        {
          tag: "Prädiktive KI",
          title: "KI für gnadenlose Trader",
          desc: "KI-Prognose mit projiziertem Target, starker Unterstützung und sofort berechneter Nachfragezone. Smart Money Flow zeigt Big Buyers, Big Sellers und institutionellen Net Flow. Quant-4X Engine Monitor mit 96.7% Präzision und 23ms Latenz — institutionelle Analyse in deinem Daumen.",
        },
        {
          tag: "Sentiment",
          title: "Live-Markt-Sentiment",
          desc: "Fear & Greed Index kombiniert mit institutioneller AI Trend Analysis. Visualisiere das exakte Niveau von Markt-Gier oder -Angst auf einer Skala von 0–100, mit KI-Interpretation des möglichen Preisimpacts und Live-Orderflow. Marktemotionen übersetzt in handelbare Daten.",
        },
        {
          tag: "Events",
          title: "KI-Wirtschaftskalender",
          desc: "Kritische Makro-Events — CPI Inflation Reports, FOMC Meeting Minutes, US Senate Crypto Regulation Hearings, Ethereum-Updates — mit KI-bewerteten Impacts als KRITISCH, MITTEL oder NIEDRIG. Filter nach Land und Kategorie, KI-Interpretation des möglichen Impacts und informierte Entscheidungen vor der Masse.",
        },
        {
          tag: "On-Chain",
          title: "Whale Watch & Crypto News KI",
          desc: "Erkenne jede institutionelle Bewegung mit dem dedizierten Whale Watch-Modul. Crypto News mit AI Sentiment analysiert Schlagzeilen von Federal Reserve, BlackRock, SEC und mehr in Echtzeit, kennzeichnet jede News als BULLISCH, BEARISCH oder NEUTRAL. Dein Edge gegen Marktrauschen.",
        },
        {
          tag: "Momentum",
          title: "Short Squeeze Detector",
          desc: "Die KI erkennt Short-Kompressionen vor der Explosion. Identifiziert Preis, KI-Prognose und Trigger-Zonen mit exakten Wahrscheinlichkeiten. Früherkennung, fortgeschrittene Prognosemodelle und KI-Ziel-Modul, um vor dem Squeeze einzusteigen, nicht danach. Der Unterschied zwischen dem Anstieg folgen und sein Ursprung sein.",
        }
      ],
    },
    topwallet: {
      eyebrow: "Produkt 02 · Web3 Bildung",
      title: "TOPWALLET",
      tagline: "Dein Geld, deine Kontrolle",
      description: "Eine moderne Plattform mit Fokus auf digitales Geld, Blockchain und Web3. Lerne Schritt für Schritt, wie die neue Wirtschaft funktioniert: Wallets, Netzwerke, DeFi, Sicherheit und Überweisungen — mit professionellen Infografiken und einfachen Erklärungen.",
      open_web: "Web-Version öffnen",
      under_construction: "Im Aufbau",
      under_construction_note: "Wir bauen TopWallet. Schau bald wieder vorbei, um auf die Plattform zuzugreifen.",
      placeholder_note: "Screenshots und finale Bilder folgen demnächst.",
      compare_cta: "Vergleich von 35 Wallets",
      concepts: [
        {
          title: "Digitale Wallets",
          desc: "Lerne, was Wallets sind, wie man sie erstellt und wie man private Schlüssel schützt.",
        },
        {
          title: "Blockchain-Netzwerke",
          desc: "Entdecke, wie dezentrale Netzwerke, Nodes und Konsens funktionieren.",
        },
        {
          title: "Digitale Sicherheit",
          desc: "Seed-Phrasen, Hardware Wallets und Best Practices gegen Betrug.",
        },
        {
          title: "DeFi & Überweisungen",
          desc: "Tokens, Swaps, Staking und On-Chain-Bewegungen visuell erklärt.",
        }
      ],
    },
    cta_band: {
      title: "Tritt der Rebellion bei",
      subtitle: "Sei unter den Ersten, die mit dem REBEL-Ökosystem traden und lernen.",
      button: "Ins Ökosystem eintreten",
    },
    footer: {
      tagline: "Eine REBEL-Marke · Trading + Web3 Bildung",
      rights: "Alle Rechte vorbehalten.",
      ecosystem: "Ökosystem",
      legal: "Rechtliches",
      terms: "AGB",
      privacy: "Datenschutz",
      contact: "Kontakt",
      blog: "Blog",
      resources: "Ressourcen",
    },
    social: {
      title: "Verbinde dich mit RE₿EL",
      subtitle: "Folge unseren institutionellen Analysen, künstlicher Intelligenz, realen Ergebnissen, Markt-Updates und exklusiven Inhalten der RE₿EL-Community.",
      follow: "Folgen",
      visit: "Besuchen",
      x: {
        handle: "@ShibaInuWorld_",
        desc: "KI-gestützte institutionelle Intelligenz für Kryptowährungen. Echtzeit-Analysen, Liquidität, Smart Money und Marktchancen.",
      },
      youtube: {
        handle: "@satoshin_gmx",
        desc: "Marktanalysen, Bitcoin, Kryptowährungen, auf Trading angewandte künstliche Intelligenz und Finanzbildung.",
      },
      facebook: {
        handle: "Peter Stanga",
        desc: "Gründer von RE₿EL. Entwicklung künstlicher Intelligenz für den Kryptomarkt, institutionelle Analysen und Aufbau des RE₿EL-Ökosystems.",
      },
      telegram: {
        handle: "@RebelBTCoficial",
        desc: "Offizieller RE₿EL-Kanal. Echtzeit-Analysen, Liquidations-Alerts und Plattform-Updates.",
        cta: "Beitreten",
      },
      website: {
        handle: "rebelbtc.com",
        desc: "Professionelle Plattform für künstliche Intelligenz zur Analyse von Kryptowährungen, institutioneller Liquidität und Smart Money Tracking.",
      },
    },
  },
  "zh-CN": {
    nav: {
      trendia: "TrendIA",
      topwallet: "TopWallet",
      liquidity_map: "Liquidity Map",
      launch: "2026年发布",
      academy: "RE₿EL学院 · 免费",
      vault: "Vault",
      governance: "Governance",
      burn: "Burn",
      login: "登录",
      account: "我的账户",
      logout: "退出登录",
      upgrade: "解锁PRO版",
      section_learn: "学习",
      section_trade: "交易",
      section_community: "社区",
      section_token: "$RE₿EL代币",
      section_tools: "我的工具",
    },
    auth: {
      login_title: "登录您的账户",
      login_sub: "继续您在RE₿EL学院的学习之旅",
      register_title: "免费创建账户",
      register_sub: "阅读51节课程 · 无需信用卡",
      email: "电子邮箱",
      password: "密码",
      name: "姓名(可选)",
      submit_login: "登录",
      submit_register: "创建账户",
      google_btn: "使用Google继续",
      or_divider: "或",
      google_processing: "正在通过Google验证…",
      switch_to_register: "还没有账户?创建一个",
      switch_to_login: "已有账户?登录",
      close: "关闭",
      error_generic: "出现问题。请重试。",
      free_perks: "免费访问51节课程",
      pro_perks: "Onyx语音 + AI导师,一次性支付39.90€",
      google_linked: "通过Google连接",
    },
    pro: {
      gate_title: "PRO功能",
      gate_listen: "解锁超逼真的Onyx语音,聆听51节课程",
      gate_mentor: "与AI导师(Claude Sonnet 4.5)讨论任何课程",
      price_label: "一次性付款",
      price: "39.90 €",
      lifetime: "终身访问",
      cta_unlock: "解锁PRO版",
      cta_login_first: "登录以解锁",
      includes_title: "包含:",
      includes: [
        "所有课程的Onyx人声",
        "Claude Sonnet 4.5个人AI导师",
        "每节课的智能上下文",
        "终身访问 · 无需续费"
      ],
      processing: "正在处理您的付款…",
      success: "欢迎来到PRO生态系统!🎉",
      cancelled: "付款已取消。当您准备好时,我们随时在这里。",
      trial_expired_title: "您已完成51节课程!🎉",
      trial_expired_sub: "您的试用访问已结束。获取终身PRO版,随时使用AI导师和Onyx语音。",
      trial_used_listen_title: "您已使用Onyx语音的免费试用🎧",
      trial_used_mentor_title: "您已使用AI导师的免费消息🤖",
      trial_used_sub: "要继续使用Onyx语音聆听课程并随时与AI导师对话,请获取终身PRO版。",
      gate_listen_b: "您的课程,用接近真人的Onyx语音讲述🎧",
      gate_mentor_b: "您的个人AI导师在等您,价格比一份披萨还便宜🍕",
      trial_used_listen_title_b: "Onyx语音让您着迷了,对吧?🎧",
      trial_used_mentor_title_b: "与这样的导师一次对话是不够的🤖",
      trial_used_sub_b: "AI导师 + Onyx语音终身无限使用。一次性39.90€。永不取消,因为没有什么需要取消。",
      cta_unlock_b: "我要终身PRO版",
    },
    hero: {
      eyebrow: "REBEL生态系统 · 发布",
      title_1: "数字货币的",
      title_2: "革命",
      title_3: "已经开始",
      subtitle: "7个工具。一个愿景。TrendIA、R₿L Coin、学院、Shadow Network、Shadow Market、Liquidity Map和TopWallet。最完整的加密生态系统触手可及。欢迎加入革命。",
      cta_primary: "探索TrendIA",
      cta_secondary: "发现TopWallet",
      scroll: "滑动探索",
    },
    trendia: {
      eyebrow: "产品01 · AI交易应用",
      title: "TrendIA",
      tagline: "为无情交易者打造的人工智能",
      description: "高概率信号、实时流动性地图、机构分析和毫米级精确度——全在您的口袋中,由Quant-4X引擎驱动。",
      features: [
        {
          title: "预测AI",
          desc: "预测市场走势的先进模型。",
        },
        {
          title: "实时强制平仓",
          desc: "实时监控关键区域和Cluster。",
        },
        {
          title: "高级分析",
          desc: "图表、指标和机构趋势。",
        },
        {
          title: "全面安全",
          desc: "您的信息受精英技术保护。",
        }
      ],
      download_play: "Google Play",
      download_web: "网页版",
      coming_soon: "即将推出",
      available_now: "现已推出",
      gallery_eyebrow: "功能 · TrendIA应用",
      gallery_title: "一个AI。七种超能力。",
      gallery_subtitle: "每个屏幕都解决交易者的真实问题。全部连接到Quant-4X引擎。",
      gallery: [
        {
          tag: "流动性",
          title: "实时强制平仓",
          desc: "BTC、ETH、SOL、ZEC等的强制平仓Cluster实时地图,概率精确到毫米级。可视化做多和做空可能连环爆仓的关键区域,显示目标百分比、与当前价格的距离和可能的走向。根据订单簿操作,而非凭感觉。",
        },
        {
          tag: "分析",
          title: "智能分析 · 精确决策",
          desc: "实时AI信号,历史置信度95%,验证精确度92.4%。在一个屏幕上显示方向、波动性、动量、强度、流动性和情绪。BTC、ETH、SOL和ZEC的市场热图,集成Cointelegraph和The Block新闻。",
        },
        {
          tag: "预测AI",
          title: "为无情交易者打造的AI",
          desc: "AI预测,即时计算目标、强支撑位和需求区。Smart Money Flow显示大买家、大卖家和机构净流量。Quant-4X Engine监控器,精确度96.7%,延迟23毫秒——触手可及的机构分析。",
        },
        {
          tag: "情绪",
          title: "实时市场情绪",
          desc: "恐惧贪婪指数结合机构AI趋势分析。在0-100刻度上可视化市场贪婪或恐惧的确切水平,AI解读对价格的可能影响和实时订单流。市场情绪转化为可操作数据。",
        },
        {
          tag: "事件",
          title: "AI经济日历",
          desc: "关键宏观事件——CPI通胀报告、FOMC会议纪要、美国参议院加密监管听证会、Ethereum更新——AI评估影响为关键、中等或低。按国家和类别筛选,AI解读可能影响,在大众之前做出明智决策。",
        },
        {
          tag: "链上",
          title: "巨鲸监控 & AI加密新闻",
          desc: "通过专用巨鲸监控模块检测每个机构动向。加密新闻与AI情绪分析实时分析美联储、BlackRock、SEC等标题,将每条新闻标记为看涨、看跌或中性。您对抗市场噪音的优势。",
        },
        {
          tag: "动量",
          title: "轧空探测器",
          desc: "AI在爆发前检测空头压缩。识别价格、AI预测和触发区域,概率精确。早期检测、先进预测模型和AI目标模块,让您在轧空前进入,而非事后追涨。主动与被动的区别。",
        }
      ],
    },
    topwallet: {
      eyebrow: "产品02 · Web3教育",
      title: "TOPWALLET",
      tagline: "您的钱,您做主",
      description: "专注于数字货币、区块链和Web3的现代平台。逐步学习新经济如何运作:钱包、网络、DeFi、安全和转账——配有专业信息图和简单解释。",
      open_web: "打开网页版",
      under_construction: "建设中",
      under_construction_note: "我们正在建设TopWallet。请稍后返回访问平台。",
      placeholder_note: "最终截图和图片即将推出。",
      compare_cta: "35个钱包对比工具",
      concepts: [
        {
          title: "数字钱包",
          desc: "了解钱包是什么、如何创建以及如何保护您的私钥。",
        },
        {
          title: "区块链网络",
          desc: "发现去中心化网络、节点和共识机制如何运作。",
        },
        {
          title: "数字安全",
          desc: "助记词、硬件钱包和防诈骗最佳实践。",
        },
        {
          title: "DeFi & 转账",
          desc: "代币、交换、质押和链上操作的可视化解释。",
        }
      ],
    },
    cta_band: {
      title: "加入革命",
      subtitle: "成为首批使用REBEL生态系统进行交易和学习的人。",
      button: "进入生态系统",
    },
    footer: {
      tagline: "REBEL品牌 · 交易 + Web3教育",
      rights: "保留所有权利。",
      ecosystem: "生态系统",
      legal: "法律",
      terms: "条款",
      privacy: "隐私",
      contact: "联系",
      blog: "博客",
      resources: "资源",
    },
    social: {
      title: "连接RE₿EL",
      subtitle: "关注我们的机构分析、人工智能、真实结果、市场更新和RE₿EL社区的独家内容。",
      follow: "关注",
      visit: "访问",
      x: {
        handle: "@ShibaInuWorld_",
        desc: "AI驱动的加密货币机构情报。实时分析、流动性、Smart Money和市场机会。",
      },
      youtube: {
        handle: "@satoshin_gmx",
        desc: "市场分析、Bitcoin、加密货币、应用于交易的人工智能和金融教育。",
      },
      facebook: {
        handle: "Peter Stanga",
        desc: "RE₿EL创始人。应用于加密市场的人工智能开发、机构分析和RE₿EL生态系统建设。",
      },
      telegram: {
        handle: "@RebelBTCoficial",
        desc: "RE₿EL官方频道。实时分析、强制平仓警报和平台新闻。",
        cta: "加入",
      },
      website: {
        handle: "rebelbtc.com",
        desc: "用于加密货币分析、机构流动性和Smart Money跟踪的专业人工智能平台。",
      },
    },
  },
};
